var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-activities-wrapper"
    },
    [
      _vm.loading ? _c("span", [_vm._m(0)]) : _vm._e(),
      _vm._v(" "),
      _vm.activitiesList.length === 0 && !_vm.loading
        ? _c("courseware-companion-box", {
            attrs: {
              mood: "sad",
              msgCompanion: _vm.$gettext(
                "Es wurden keine Aktivitäten gefunden."
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "cw-dashboard-activities"
        },
        _vm._l(_vm.activitiesList, function(item, index) {
          return _c("courseware-activity-item", {
            key: index,
            attrs: {
              item: item
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "loading-indicator"
      },
      [
        _c("span", {
          staticClass: "load-1"
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "load-2"
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "load-3"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }